function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Language = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M13.251 15.256c-.992-1-2.413-2.37-2.719-2.662l.3-.334c.933-1.05 1.566-1.906 2.197-3.038.539-.968 1.049-2.108 1.567-3.522H17.5V4.2h-7.25V2h-1.5v2.2H1.5v1.5h11.494c-.425 1.106-.843 2.015-1.275 2.792-.572 1.027-1.142 1.797-2.009 2.772l-.22.246C8.33 10.24 7.508 9.1 7.01 8h-1.62c.549 1.509 1.565 2.975 3.081 4.618a84.95 84.95 0 0 1-1.727 1.754l-.231.23a213.472 213.472 0 0 1-3.24 3.128l1.03 1.091a130.917 130.917 0 0 0 1.02-.972c.764-.733 1.529-1.475 2.243-2.18l.234-.232a87.831 87.831 0 0 0 1.716-1.74c.457.439 2.313 2.23 3.146 3.098l.59-1.539zM20.707 22h1.967l-4.325-11.978h-2.008L12.016 22h1.934l1.096-3.237h4.565L20.707 22zm-3.404-9.986h.05l1.785 5.255h-3.62l1.785-5.255z"
}, " "));

Language.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Language;